module.exports = __webpack_public_path__ + "static/media/IDA-Pro-Computer-License-Linux.b578775e.png";